import { useEffect, useState } from 'react'
import "./NavBar.css";

/* 
Gallery for showing thumbnails in a list
*/

//@ts-ignore
import LocalStorageInterFace from './PaintProgram/3_brush_controls/filesystem/LocalStorage'
import { Link } from 'react-router-dom';
import GoogleSignIn from '../GoogleSignIn';
import { SUB_FOLDER, URL_BACKEND } from '../../CONSTANTS';
import { userStore } from '../../App';
import UserInterface, { UserData } from '../../User';


function NavBar() 
{
    // let {user} = props;

    const user = userStore((state) => state.user);
    const setUser = userStore((state) => state.setUser);

  const [count, setCount] = useState(0);
  const [gallery_items, setGalleryItems] = useState(new Array());

  function SignOut()
  {
    console.log("signing out!");
    UserInterface.SignOut();
    setUser(null);
  }


  useEffect(() => {
    

    
    }, []); // Empty array means this effect runs once on mount and clean up on unmount



  return (
    <>

    
        <nav>
            <ul>
                <li><Link to={SUB_FOLDER+"/"}>Home</Link></li>
                {
                    user&&user.token?
                    (
                        <li className='drop_down'>
                            <img className='avatar' src={URL_BACKEND+user.avatar}/>
                            <ul >
                                <li><Link to={SUB_FOLDER+"Profile"} state={{ user: user }}>Profile</Link></li>
                                <li><a href='#' onClick={()=>{SignOut();}}>Logout</a></li>
                            </ul>
                            </li>
                    ):
                    (
                        // <li><Link to="/Login">Login</Link></li>
                        <li><GoogleSignIn/></li>
                    )
                }
                
            </ul>
        </nav>
    
    
    
    </>
  )
}

export default NavBar
